<script lang="ts" setup>
import { useModal } from "tir-pm-toolkit";
import {
  TirPmModal,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from "tir-components";
import { TaskParameterModel } from "@/components";
import { ref } from "vue";

/**Параметры */
const props = defineProps({
  /**Имя области */
  namespaceName: { type: String },
});
/**События */
const emit = defineEmits<{
  /**Подтверждение удаления параметра */
  remove: [parameterName: string];
}>();

/**Управление окном */
const { visible, open, close } = useModal();
/**Заголовок окна */
const title = ref("");
/**Удаляемый параметр */
const removing = ref<TaskParameterModel>();

/**Открытие окна */
const openModal = (_removing: TaskParameterModel, _basic: TaskParameterModel) => {
  if (!_removing || !_basic) return;

  removing.value = _removing;

  title.value = `Атрибут "${_removing.Name}" во всех тикетах рабочей области "${props.namespaceName}" будет заменен на "${_basic.Name}`;
  open();
};
/**Подтверждение удаления */
const confirmRemove = () => {
  emit("remove", removing.value?.Name);
  close();
};

/**Код для использования по ref */
defineExpose({ open: openModal });
</script>
<template>
  <TirPmModal
    classes="parameter-remove-modal"
    :isCloseOverlay="true"
    :isWithBack="false"
    :title="title"
    :is-visible="visible"
    @close="close"
  >
    <template #footer>
      <TirPmButton
        :size="TirPmButtonSizeEnum.Regular"
        :variant="TirPmButtonVariantEnum.PrimaryState"
        @click="confirmRemove"
      >
        Продолжить
      </TirPmButton>
      <TirPmButton
        :size="TirPmButtonSizeEnum.Regular"
        :variant="TirPmButtonVariantEnum.SecondaryState"
        @click="close"
      >
        Отменить
      </TirPmButton>
    </template>
  </TirPmModal>
</template>
<style lang="scss">
.parameter-remove-modal.modal {
  width: 53.75rem;
}
</style>
